import { UserGetAdapter } from '../../../../adapter';

export default async function HandleUserGet(event) {
    const requestUrl = 'https://nwtbrglvql.execute-api.ap-southeast-1.amazonaws.com/api/procurement/user/get';

    const payload = {
        data: {
            userData: {
                ...event
            },
            signature: ''
        }
    };

    // handle request
    const result = await UserGetAdapter(requestUrl, JSON.stringify(payload));

    return result;
}
